module.exports = __webpack_public_path__ + "img/tesla_320.d078a724.png";